import {
  HowDoYouGetPaidSelectionInput,
  SaveHowDoYouGetPaidSelectionResult,
  SaveHowDoYouGetPaidSelectionResultTypenames,
} from '@varo/graphql-schema-types';
import SaveHowDoYouGetPaidSelection from 'services/graphql/mutations/onboarding/SaveHowDoYouGetPaidSelection.mutation';
import useCancellableMutation, {
  AbortError,
} from 'shared/hooks/useCancellableMutation';

const selectionIdToInput: Record<string, HowDoYouGetPaidSelectionInput> = {
  DIRECT_DEPOSIT: HowDoYouGetPaidSelectionInput.DirectDeposit,
  PAYMENT_APP: HowDoYouGetPaidSelectionInput.PaymentApp,
  CASH: HowDoYouGetPaidSelectionInput.Cash,
  CHECK: HowDoYouGetPaidSelectionInput.Check,
  ANOTHER_WAY: HowDoYouGetPaidSelectionInput.AnotherWay,
};

const useSaveHowDoYouGetPaidSelection = () => {
  const [{ fetching }, executeMutation] = useCancellableMutation<{
    saveHowDoYouGetPaidSelection: SaveHowDoYouGetPaidSelectionResult;
  }>(SaveHowDoYouGetPaidSelection);

  const saveSelection = async (selectedOptionId: string): Promise<boolean> => {
    const selection =
      selectionIdToInput[selectedOptionId] ??
      HowDoYouGetPaidSelectionInput.Undefined;

    try {
      const result = await executeMutation({
        input: {
          selection,
          timestamp: new Date().toISOString(),
        },
      });

      return (
        result.data?.saveHowDoYouGetPaidSelection?.__typename ===
        SaveHowDoYouGetPaidSelectionResultTypenames.SaveHowDoYouGetPaidSelectionSuccess
      );
    } catch (err) {
      if (err instanceof AbortError) {
        return false;
      }
      throw err;
    }
  };

  return {
    saveSelection,
    isSaving: fetching,
  };
};

export default useSaveHowDoYouGetPaidSelection;
